<script setup lang="ts">

import type {MenuItem} from "primevue/menuitem";
import Sidebar from 'primevue/sidebar';
import {onMounted} from "@vue/runtime-core";
import {useUserDataStorage} from "~/store/userdata";
import menu from "primevue/menu";
import {useModyApi} from "~/middelware/ModyApi";
import logoUrl from "~/assets/img/rgb_negativ.png"
import MainMenu from "./MainMenu.vue";

const router = useRouter()

const visible = ref(false)
const userDataStore = useUserDataStorage();
const {user, loggedIn}= storeToRefs(userDataStore)
const menuItemIds = {
  home:0,
  about:1,
  shop:2,
  request:3,
  newsletter:4,
  blog:5,
  admin:6
}
const productsInCart = computed(()=>{
  return userDataStore.browserCart?.products.length
})
const menuItems = ref<MenuItem[]>([
{
  label: "Home",
  command: ()=>{router.push("/")},
},
{
  label: "Unternehmen",
  items:[
  {
    label:"Kontakt",
    command: ()=>{router.push("/contact")},
    url:"/contact"
  },
  {
    label:"Impressum",
    command: ()=>{router.push("/impressum")},
    url:"/impressum"
  },
  {
    label:"Datenschutz",
    command: ()=>{router.push("/privacy")},
    url:"/privacy"
  },
  {
    label:"AGBs",
    command: ()=>{router.push("/agb")},
    url:"/agb"
  },
  ]
},
{
  label: "Sortiment",
  command: ()=>{router.push("/shop")},
  url:"/shop"
},
{
  label:"Anfrage",
  command: ()=>{router.push("/shop/request")},
  url:"/shop/request",
  badge: productsInCart
},
{
  label:"Blog",
  command: ()=>{router.push("/blog")},
  url:"/blog"
},
{
  label:"Newsletter",
  command: ()=>{router.push("/newsletter")},
  url:"/newsletter"
},
{
  label: "Administration",
  visible:false,
  command: ()=>{router.push("/admin/adminProducts")},
  url:"/admin/adminProducts",
},
])
const modyApi = useModyApi()
onMounted(()=>{
  setAdministrationVisibility()
})
watch(user, ()=>{
  setAdministrationVisibility()
})
function setAdministrationVisibility(){
  console.log(user.value?.role)
  menuItems.value[menuItemIds.admin].visible = user.value?.role? user.value?.role.name == "Authenticated" : false;
}

</script>
<template>
  <div class="flex justify-between">
    <MainMenu :model="menuItems" > </MainMenu>
    <img :src="logoUrl" alt="Logo" @click="navigateTo('/')" class="h-16 w-auto ps-4 cursor-pointer"></img>
  </div>
</template>

<style scoped lang="scss">

</style>
